export default __webpack_public_path__ + "static/media/arrow-back-to-top.6c4bca5f.png";